// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n0-1";
export var messageSideRight = "_n0-2";
export var subscribeToBackInStockBubbleContainer = "_n0-0";